import { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Grid, Typography } from '@material-ui/core';
import moment from "moment";

import { ButtonGeneric } from "../../../atomic/atoms/Buttons";
import { GenericModal } from "../../../atomic/organisms/GenericModal";
import { GenericTab } from "../../../atomic/organisms/GenericTab";
import { GenericTable } from "../../../atomic/organisms/GenericTable";
import { DatePickerGeneric } from "../../../atomic/atoms/DatePicker";
import { SelectGeneric } from "../../../atomic/atoms/Select";
import Buscador from "../../../../actions/ui/Buscador";
import { esFechaValida } from "../../../../helpers/date";
import { useTotem } from "../../../../hooks/useCases/useTotem";


const center = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

const initModal = {
    open: false,
    value: null
};
  
export const AreasRecepcionista = () => {
    const componentRef  = useRef();
    const totem  = useTotem();
  
    const { idUsuario, userName } = useSelector((state) => state.auth)
  
    const [afiliado, setAfiliado] = useState(null);
    const [modal, setModal] = useState(initModal);
  
    const [search, setSearch] = useState({
      idRecepcion: totem.data.recepcionesUsuario[0].id,
      confirmado: false,
      fechaDesde: moment(),
      fechaHasta: moment(),
      idAfiliado: ""
    });
  
    const solicitudes = search.confirmado 
      ? totem.data.solicitudesAfiliados.filter(item => !!item.idUserConfirmacion)
      : totem.data.solicitudesAfiliados.filter(item => !item.idUserConfirmacion);
  
    const dataDates = [
      {value: search.fechaDesde, onChange: (date) => { setSearch({...search, fechaDesde: date}) }, label: "Fecha Desde"},
      {value: search.fechaHasta, onChange: (date) => { setSearch({...search, fechaHasta: date}) }, label: "Fecha Hasta"},
    ];
  
    const searchSolicitudes = () => {
      if(
        (!!esFechaValida(search.fechaDesde) && !!esFechaValida(search.fechaHasta)) && 
        (search.fechaDesde <= search.fechaHasta)
      ){
        const dataSearch = {
          ...search,
          fechaDesde: moment(search.fechaDesde).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
          fechaHasta: moment(search.fechaHasta).endOf('day').format('YYYY-MM-DDTHH:mm:ss') 
        };
        totem.search.solicitudesRecepcionesUsuario(dataSearch);
      }
    }
  
    const intervalRef = useRef(null);
    useEffect(() => {
      searchSolicitudes();
  
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          searchSolicitudes();
        }, 5000);
      }
  
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };
  
    }, [ search ]);
  
    const tabs = totem.data.recepcionesUsuario.map((item) => ({
      label: item.descripcion,
      onClickTab: () => { setSearch({...search, idRecepcion: item.id}) },
      component: (
        <div style={{width: "100%"}}>
          <Grid container justify='space-around'>
            <Grid item xs={12} md={6} style={{backgroundColor: "#FFF", border: "1px solid #ccc", padding: "0 0.5em"}}>
              <Buscador 
                ref={componentRef}
                value={afiliado}
                setValue={(val) => { 
                  setAfiliado(val); 
                  setSearch({...search, idAfiliado: val?.idAfiliado || ""}); 
                }}
                label="Nombre Afiliado | Carnet"
                noOptionText="No se encuentra afiliado"
                endpoint={(inputValue) => `TotemRecepcionistas/Afiliado/Search?buscador=${inputValue}`}
                getOptionLabel={(option) => `NOMBRE: ${option.nombreApellido.toUpperCase().trim()} - CARNET: ${option.carnet}`}
                renderOption={(option) => (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {`NOMBRE: ${option.nombreApellido.toUpperCase().trim()} - CARNET: ${option.carnet}`}
                  </div>
                )}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <SelectGeneric 
                style={{borderRadius: 0}}
                variant="outlined"
                label="Solicitudes"
                name="confirmado"
                value={search.confirmado}
                onChange={(e) => { setSearch({...search, confirmado: e.target.value}) }}
                menuItems={[
                  {
                    value: false,
                    label: "Solicitudes Pendientes"
                  },
                  {
                    value: true,
                    label: "Solicitudes Confirmadas"
                  }
                ]}
              />
            </Grid>
            {dataDates.map(({value, onChange, label}, index) => (
              <Grid key={index} item xs={12} md={2} style={{...center, backgroundColor: "#FFF", border: "1px solid #ccc"}}>
                <DatePickerGeneric 
                  style={{padding: "0 0.5em"}}
                  value={value}
                  label={label}
                  onChange={onChange}
                  fullWidth
                  {...(index === 0) ? {maxDate: search.fechaHasta} : {minDate: search.fechaDesde}}
                />
              </Grid>
            ))}
            <Grid item xs={12}>
              <GenericTable 
                ref={componentRef}
                data={solicitudes}
                align="center"
                columns={[
                  {
                    id: "id",
                    label: "N° Solicitud"
                  },
                  {
                    id: "afiliado.nombreApellido",
                    label: "Afiliado"
                  },
                  {
                    id: "afiliado.carnet",
                    label: "Carnet Afiliado"
                  },
                  {
                    label: "Fecha Solicitud",
                    customBody: (item) => moment(item.fechaSolicitud).format("DD/MM/YYYY - HH:mm")
                  },
                  {
                    id: "opcion.descripcion",
                    label: "Opción"
                  },
                  {
                    id: "subOpcion.descripcion",
                    label: "Sub Opción"
                  },
                  ...(search.confirmado
                    ? [
                      {
                        label: "Fecha Confirmación",
                        customBody: (item) => moment(item.fechaConfirmacion).format("DD/MM/YYYY - HH:mm")
                      },
                      {
                        id: "usuarioConfirmacion.userName",
                        label: "Usuario Confirmación"
                      }
                    ] : [
                      {
                        label: "Confirmar Solicitud",
                        customBody: (item) => (
                          <ButtonGeneric
                            type="button"
                            text="CONFIRMAR"
                            onClick={() => { 
                              setModal({open: true, value: item, title: `CONFIRMAR SOLICITUD N° ${item.id}`})
                            }}
                          />
                        )
                      }
                    ]
                  )
                ]}
              />
            </Grid>
          </Grid>
        </div>
      )
    }));
  
    return (
        <>
            <Grid item xs={12} style={{padding: "0 2em"}}>
                <GenericTab tabs={tabs} />
            </Grid>
    
            {modal.open && (
                <GenericModal
                    open={modal.open}
                    handleClose={() => { setModal(initModal) }}
                    textButton="ACEPTAR"
                    gridStyle={{ textAlign: "center" }}
                    handleButton={() => {
                    totem.update.confirmSolicitudAfiliado(
                        { id: modal.value.id },
                        {
                        ...modal.value,
                        idUserConfirmacion: idUsuario,
                        fechaConfirmacion: moment(),
                        usuarioConfirmacion: { idUsuario, userName }
                        }
                    )
                    setModal(initModal);
                    }}
                    title={
                    <Typography variant='h6'>
                        {`SOLICITUD N° ${modal.value.id} - ${modal.value.afiliado.nombreApellido}`}
                    </Typography>
                    }
                >
                    <Typography variant='button' style={{fontSize: "1.1em"}}>
                    Desea confirmar esta solicitud?
                    </Typography>
                </GenericModal>
            )}
        </>
    )
}